import { createPortal } from 'react-dom';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { setGiftCardError } from '@/modules/perseo-billing/store/slices/billing';
import {
  Button,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

import { ModalWrapper, Tooltip } from '../../components';

export const ModalGiftCardError = () => {
  const giftCardError = useAppSelector((state) => state.billing.giftCardError);
  const dispatch = useAppDispatch();

  const title = giftCardError?.title ?? '';
  const message = giftCardError?.message ?? '';
  const innerCustomCode = giftCardError?.errorCode ?? '';

  const modalContent = (
    <ModalWrapper
      size="lg"
      roundedType="FIXED_BOTTOM"
      open={!!giftCardError}
      onClose={() => false}
    >
      <Card className="co-gap-16px">
        <CardHeader
          pt={24}
          pr={16}
          pb={0}
          pl={16}
          action={
            <Button
              onClick={() => dispatch(setGiftCardError(null))}
              icon="CloseIcon"
              size="small"
            />
          }
          title={''}
        />
        <CardContent pt={0} pr={0} pb={0} pl={0}>
          <div className="co-flex co-flex-col co-gap-32px co-px-16px co-justify-start co-items-center lg:co-gap-16px">
            <Icon width={200} height={148} icon="BillingGiftCardError" />
            <div className="co-flex co-flex-col co-gap-32px co-justify-center co-items-center co-w-2/3">
              <Typography size="h2" weight="semibold" align="center">
                {title}
              </Typography>
              <Typography color="gray-dark" align="center">
                {message}
              </Typography>
            </div>
            <div className="co-flex co-flex-col lg:co-hidden co-items-center co-gap-32px">
              <Button
                pl={32}
                pr={32}
                variant="contained"
                color="primary"
                type="button"
                fullWidth={false}
                onClick={() => dispatch(setGiftCardError(null))}
              >
                Continuar con otro medio de pago
              </Button>
              <ErrorCode error={innerCustomCode} />
            </div>
          </div>
        </CardContent>

        <CardFooter className="co-hidden lg:co-flex lg:co-flex-col co-items-center co-p-32px co-gap-32px">
          <Button
            pl={32}
            pr={32}
            variant="contained"
            color="primary"
            type="button"
            className="co-w-1/2"
            onClick={() => {
              dispatch(setGiftCardError(null));
            }}
          >
            Continuar con otro medio de pago
          </Button>
          <ErrorCode error={innerCustomCode} />
        </CardFooter>
      </Card>
    </ModalWrapper>
  );

  const modalElement = document.getElementById('modal-giftcard-fallback');

  return modalElement ? createPortal(modalContent, modalElement) : null;
};

const ErrorCode = ({ error }: Record<string, string>) => {
  return (
    <div className="co-flex co-gap-8px co-items-center">
      <Typography weight="semibold" color="neutral-grey-500" noWrap>
        {'Código de error: '}
        <span className="co-font-normal co-text-neutral-grey-500">{error}</span>
      </Typography>
      <Tooltip title="Este código es para uso interno de Paris." />
    </div>
  );
};
